import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Sent written communication' },
    { value: 2, label: 'Conversation with whānau' },
    { value: 3, label: 'Developed individual support plan' },
    { value: 4, label: 'Used in-school resources to reduce barriers' },
    { value: 5, label: 'Positive reinforcement' },
    { value: 6, label: 'Referred to external agencies' },
    { value: 7, label: 'Initiated prosecution' },
    { value: 8, label: 'Unsuccessful contact attempt' },
    { value: 9, label: 'Monitor current approach' },
    { value: 99, label: 'Other' },
  ],
});
